import PropTypes from "prop-types";
import { useState } from "react";
import CheckInImageUpload from "./CheckInImageUpload";

const WALKAROUND_POINTS = [
    { key: "front", name: "Front", number: "1" },
    { key: "frontRight", name: "Front right", number: "2" },
    { key: "rightSide", name: "Right Side", number: "3" },
    { key: "rearRight", name: "Rear Right", number: "4" },
    { key: "rear", name: "Rear", number: "5" },
    { key: "rearLeft", name: "Rear Left", number: "6" },
    { key: "leftSide", name: "Left side", number: "7" },
    { key: "frontLeft", name: "Front left", number: "8" },
];

const MAX_DAMAGE_PHOTOS = 5;

const filesFromImages = (images) => {
    const files = {};
    images.forEach((image) => {
        if (image.uploadedImageFile) {
            files[image.key || `image-${image.id}`] = image.uploadedImageFile;
        }
    });
    return files;
};

const CheckInImageCapture = ({ onImagesChange, t }) => {
    const [images, setImages] = useState(() =>
        WALKAROUND_POINTS.map((point, index) => ({
            id: index + 1,
            name: point.name,
            key: point.key,
            number: point.number,
            initialPlaceholder: "",
            uploadedImageFile: "",
            create: false,
        })),
    );

    const handleFileSelect = (newImageObj) => {
        setImages((prev) => {
            let next;

            if (newImageObj.create) {
                next = [
                    ...prev,
                    {
                        ...newImageObj,
                        create: false,
                        id: Math.max(0, ...prev.map((image) => image.id)) + 1,
                        key: `damage${prev.filter((image) => image.key?.startsWith("damage")).length + 1}`,
                    },
                ];
            } else {
                const isRemoved = !newImageObj.uploadedImageFile;
                const isDamage = Boolean(newImageObj.key?.startsWith("damage"));

                next =
                    isRemoved && isDamage
                        ? prev.filter((image) => image.id !== newImageObj.id)
                        : prev.map((image) =>
                              image.id === newImageObj.id
                                  ? { ...image, uploadedImageFile: newImageObj.uploadedImageFile }
                                  : image,
                          );

                if (isRemoved && isDamage) {
                    let damageIndex = 0;
                    next = next.map((image) => {
                        if (!image.key?.startsWith("damage")) return image;
                        damageIndex += 1;
                        return { ...image, key: `damage${damageIndex}` };
                    });
                }
            }

            onImagesChange?.(filesFromImages(next));
            return next;
        });
    };

    const capturedCount = images.filter((image) => !image.key?.startsWith("damage") && image.uploadedImageFile).length;
    const damageCount = images.filter((image) => image.key?.startsWith("damage")).length;
    const nextDamageId = Math.max(0, ...images.map((image) => image.id)) + 1;

    return (
        <div>
            <p className="fontRegular mb-3 text-sm text-[#667085]">
                {capturedCount} {t("of")} {WALKAROUND_POINTS.length} {t("photosCaptured")}
            </p>

            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
                {images.map((imageObj) => (
                    <CheckInImageUpload
                        key={imageObj.id}
                        handleFileSelect={handleFileSelect}
                        imageObj={imageObj}
                        t={t}
                    />
                ))}
            </div>

            {damageCount < MAX_DAMAGE_PHOTOS ? (
                <CheckInImageUpload
                    handleFileSelect={handleFileSelect}
                    imageObj={{
                        id: nextDamageId,
                        name: t("damagePhoto"),
                        initialPlaceholder: "",
                        uploadedImageFile: "",
                        create: true,
                    }}
                    t={t}
                />
            ) : null}
        </div>
    );
};

CheckInImageCapture.propTypes = {
    onImagesChange: PropTypes.func,
    t: PropTypes.func.isRequired,
};

export default CheckInImageCapture;
